import { BreakpointsStateInterface, defaultBreakpoints } from '@systemeio/util'
import { DeviceTypeEnum } from 'shared/hooks/use-metadata-from-server'
import { serverDeviceBreakpointOverrides } from '../constants/server-device-breakpoint-overrides'

export const getBreakpointsByServerDeviceType = (
  serverDeviceType: DeviceTypeEnum = DeviceTypeEnum.Unknown,
): BreakpointsStateInterface => ({
  ...defaultBreakpoints,
  ...serverDeviceBreakpointOverrides[serverDeviceType],
})
